import { PreparationScreen, PreparationScreenInput } from 'modules/overlay-v2/domain/interfaces/readiness';

/**
 * Решает, что видит зритель, пока матч готовится.
 *
 * Первое открытие страницы показывает чеклист: оператор ещё ни разу не видел, что всё
 * работает. Переключение матча после эфира — только знак ImGame: оверлей висит в OBS, и
 * чеклист во весь экран между матчами видят зрители. Чеклист при переключении выходит,
 * только если что-то упало или подготовка затянулась, и остаётся до готовности.
 */
export function resolvePreparationScreen(input: PreparationScreenInput): PreparationScreen {
  if (input.hasGoneLive) return 'none';
  if (!input.hasEverGoneLive) return 'checklist';
  if (input.isChecklistEscalated || input.failedStepId || input.isTimedOut) return 'checklist';
  return 'switchLoader';
}
